import { render, staticRenderFns } from "./Pengaduan.vue?vue&type=template&id=fee71a0a&scoped=true&"
import script from "./Pengaduan.vue?vue&type=script&lang=js&"
export * from "./Pengaduan.vue?vue&type=script&lang=js&"
import style0 from "./Pengaduan.vue?vue&type=style&index=0&id=fee71a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee71a0a",
  null
  
)

export default component.exports